<template>
	<div>
		<h2>
			{{ $t('edit-test') }}
			<div class="float-right">
				<button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
			</div>
		</h2>

		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('saved') }}</div>
		</div>

		<div class="row">
			<div class="col">

				<div class="form-group">
					<label>{{ $t('code') }}</label>
					<input class="form-control" v-model="test.Code" />
				</div>

				<div class="form-group">
					<label>{{ $t('name') }}</label>
					<input class="form-control" v-model="test.Name" />
				</div>


				<div class="form-group">
					<label>{{ $t('form') }}</label>
					<input
						type="text"
						:value="selectedFormTitle"
						class="form-control"
						@focus="selectForm"
					/>
				</div>

				<div class="form-group">
					<label>{{ $t('outcome') }}</label>
					<select class="form-control" v-model="test.dichotomy_id">
						<option v-for="dichotomy in $config.getValue('dichotomies')" :key="dichotomy.id" :value="dichotomy.id">
							{{dichotomy.true}} / {{dichotomy.false}}
						</option>
					</select>
				</div>

				<div class="form-group">
					<label>{{ $t('published-state') }}</label>
					<select class="form-control" v-model="test.PublishedState">
						<option value="1">{{ $t('enabled') }}</option>
						<option value="10">{{ $t('disabled') }}</option>
					</select>
				</div>

				<b-form-group>
	                <b-form-checkbox v-model="test.competencytest_canretake" :unchecked-value="0" :value="1">
	                {{ $t('can-retake') }}
	                </b-form-checkbox>
	            </b-form-group>

                <h3>{{ $t('course-year-filters') }}</h3>
                <p>{{ $t('if-filters-unchecked-available-to-all-students') }}</p>

                <!-- iterate programmes and years -->
    			<b-form-group :label="programme.Name"
				v-for="programme in $config.getValue('programmes')"
				:key="programme.Id"
    			>
					<b-form-checkbox-group>
				    	<b-form-checkbox
				    	:value="`${programme.Id}_${year}`"
				    	:key="year"
				    	v-for="year in parseInt(programme.CourseLengthYears)"
				    	v-model="test.programmeyears"
				    	>
				    	{{ $t('year') }} {{ year }}
						</b-form-checkbox>
     				</b-form-checkbox-group>
   		 		</b-form-group>


			</div>
			<div class="col">
				<div class="form-group">
					<label>{{ $t('Description') }}</label>
					<textarea class="form-control" v-model="test.Description" style="height: 297px;" />
				</div>

				<!-- filters -->
    			<b-form-group label="Filters">
					<b-form-checkbox-group>
				    	<b-form-checkbox
				    	:value="filter.competencytestfilter_id"
				    	:key="filter.competencytestfilter_id"
				    	v-for="filter in allcompetencytestfilters"
				    	v-model="test.Filters"
				    	>
				    	{{ filter.competencytestfilter_caption }}
						</b-form-checkbox>
     				</b-form-checkbox-group>
   		 		</b-form-group>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
        	test: {
        		id: null,
        		Code: null,
        		Name: null,
        		form_id: null,
        		dichotomy_id: 1,
        		PublishedState: null,
        		competencytest_canretake: null,
        		programmeyears: [],
        		Description: null,
        		Filters: [],
        	},
        	saved: false,
        	forms: [],
        	allcompetencytestfilters: []
		}
	},
	mounted() {

		Promise.all([this.getForms(), this.getAllFilters()]).then(() => {

	    	if(this.$route.params.testid) {
	    		this.getTest(this.$route.params.testid)
	    	} else {
	    		this.$store.commit("hideBlockingSpinner");
	    	}
	    });

	},
	methods: {
		selectForm() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: 'Select Form',
				selectCallback: function (selection) {
					self.test.form_id = selection.id;
					self.$store.commit("closeModal");
				},
				selected: [{ id: this.test.form_id }],
				data: this.forms,
				captionKey: 'title'
			});;
		},
		getForms() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/forms/listall`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.forms = json.results;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		save() {
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/test/save`, {
				method: 'post',
				data: {
					competencytest: this.test
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.test.id = json.competencytest.id;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getTest(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/test/load`, {
  				data: {id}
  			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {

					this.test = json.competencytest;

					//this.allcompetencytestfilters = json.allcompetencytestfilters;
					this.$nextTick(function() {
						for(const filterid of json.competencytestfilterids) {
							this.test.Filters.push(filterid);
						}
					});

					for(const programmeyear of json.programmeyears) {
						this.test.programmeyears.push(programmeyear);
					}

					this.test.competencytest_canretake = json.canretake;

				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
		},
		getAllFilters() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/filter/listall`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.allcompetencytestfilters = json.allcompetencytestfilters;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		}
	},
	computed: {
		selectedFormTitle() {
			if(this.test.form_id){
				for(const form of this.forms) {
					if(form.id == this.test.form_id) {
						return form.title;
					}
				}
			}
			return null;
		}
	}
};
</script>
